export default __webpack_public_path__ + "static/media/Group_7_low.ed017315.svg";